// extracted by mini-css-extract-plugin
export default {"container":"CommunityPatterns_container__-Kw16","header":"CommunityPatterns_header__hqoku","upFab":"CommunityPatterns_upFab__IhIsi"};